const SET_EDIT_USER = (state, user) => {
  state.editUser = user;
};

export default {
  SET_EDIT_USER,
};
